import dynamicIconImports from "lucide-react/dynamicIconImports"
import dynamic from "next/dynamic"
import { useMemo } from "react"

import { Icon, IconProps } from "./Icon"

import type { LucideIcon } from "lucide-react"

export type LucideIconName = keyof typeof dynamicIconImports

export interface DynamicIconProps extends Omit<IconProps, "icon"> {
  name: LucideIconName
}

export function DynamicIcon({ name, ...otherProps }: DynamicIconProps) {
  const icon = useMemo(
    () => dynamic(dynamicIconImports[name]) as unknown as LucideIcon,
    [name]
  )
  return <Icon icon={icon} {...otherProps} />
}
